module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="formLine   line_extr_line">\r\n    <div class="form-group col-xs-2 inputField">\r\n        <select id="fieldname" class="form-control">\r\n            ';

            _.each(desc, function (elem) {
         
                if(elem.Field != "instanceId" ){
                    if(elem.Field != "mejoras_enCurso" ){
                        if(filters.fieldname==elem.Field){
                            var selected = "selected='selected'"; 
                        }else { var selected = ""; }
                        print('<option value="' + elem.Field + '" ' + selected + '  >' + lang[elem.Field.toUpperCase()] + '</option>');
                  }
                }
                   
            });
            
__p+='\r\n        </select>\r\n    </div>\r\n\r\n    <div class="form-group col-xs-2 inputField" id="operatorHolder">\r\n        <select id="nbcomparador" class="form-control operator ';
 if(filters.nbfield != 'nbcomparador' && filters.nbfield) print('hidden')
__p+='">\r\n            <option value="=" ';
 if(filters.nbcomparador=="=") print("selected='selected'")
__p+=' >'+
((__t=(lang.IGUAL_A))==null?'':_.escape(__t))+
'</option>\r\n            <option value="<" ';
 if(filters.nbcomparador=="<") print("selected='selected'")
__p+=' >'+
((__t=(lang.MENOR_QUE))==null?'':_.escape(__t))+
'</option>\r\n            <option value=">" ';
 if(filters.nbcomparador==">") print("selected='selected'")
__p+=' >'+
((__t=(lang.MAYOR_QUE))==null?'':_.escape(__t))+
'</option>\r\n        </select>\r\n        <select id="nbIgual" class="form-control operator ';
 if(filters.nbfield!='nbIgual') print('hidden')
__p+='">\r\n            <option value="=" selected>'+
((__t=(lang.IGUAL_A))==null?'':_.escape(__t))+
'</option>\r\n        </select>\r\n        <select id="nbIncluye" class="form-control operator ';
 if(filters.nbfield!='nbIncluye') print('hidden')
__p+='">\r\n            <option value="like" selected>'+
((__t=(lang.INCLUYE))==null?'':_.escape(__t))+
'</option>\r\n        </select>\r\n    </div>\r\n    <div class="form-group col-xs-3 inputField" id="valueHolder">\r\n        <input type="text" id="textValue" class="form-control value ';
 if(filters.valuefield!='textValue' && filters.valuefield) print('hidden')
__p+=' " value="';
 if(filters.valuefield=='textValue') print(filters.value)
__p+='" />\r\n        <input type="number" id="numberValue" step="0.001" class="form-control value ';
 if(filters.valuefield!='numberValue') print('hidden')
__p+='" value="';
 if(filters.valuefield=='numberValue') print(filters.value)
__p+='" />\r\n        <div id=\'dtpickerBuscar\' class="input-group dateGroup ';
 if(filters.valuefield!='dateValue') print('hidden')
__p+='">\r\n            <input type=\'text\' id="dateValue" name="start" class="form-control date value" value="';
 if(filters.valuefield=='dateValue') print(filters.value)
__p+='" />\r\n            <span class="input-group-addon">\r\n                <span class="glyphicon glyphicon-calendar"></span>\r\n            </span>\r\n        </div>\r\n    </div>\r\n    <div class="form-group col-xs-2 inputField">\r\n        <select id="operator" class="form-control">\r\n            <option ';
 if(filters.operator!="and" && filters.operator!="or") print("selected='selected'")
__p+=' >--</option>\r\n            <option value="and" ';
 if(filters.operator=="and") print("selected='selected'")
__p+=' >'+
((__t=(lang.AND))==null?'':_.escape(__t))+
'</option>\r\n            <option value="or" ';
 if(filters.operator=="or") print("selected='selected'")
__p+=' >'+
((__t=(lang.OR))==null?'':_.escape(__t))+
'</option>\r\n        </select>\r\n    </div>\r\n    <div class="form-group col-xs-2">\r\n        <span class="searchButton add ion ion-ios-plus text-green"></span>\r\n        ';
 if(showremove){ 
__p+='\r\n            <span class="searchButton remove ion-ios-close text-red"></span>\r\n            ';
 } 
__p+='\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/masters/formLine.ejs
// module id = 428
// module chunks = 0